module.exports = __webpack_public_path__ + "static/img/car_16_5_17_5_box@3x.fbe2bea5.png";